const eventViewBannerCoupon = (params, category) => {
  if (typeof window !== 'undefined' && params) {
    (window as any)?.dataLayer?.push({
      event: 'promotionView',
      eventCategory: 'ecommerce promotion',
      eventLabel: category,
      ecommerce: {
        promoView: {
          promotions: params,
        },
      },
    });
  }
};
export default eventViewBannerCoupon;
